// Lightweight per-route scroll memory. Used to restore the games-list scroll
// position when the user opens a game and then taps Back.
const memory = new Map();

export function saveScroll(key) {
	memory.set(key, window.scrollY);
}

export function consumeScroll(key) {
	if (!memory.has(key)) return null;
	const y = memory.get(key);
	memory.delete(key);
	return y;
}
